const HIDE_ANIMATION = "modal__content__hide_animation";
const ANIMATION_DURATION = 330;

const runHideAnimation = (panelRef) => {
  const panel = panelRef?.current;
  if (!panel) return;
  panel.classList.add(HIDE_ANIMATION);
};

export { ANIMATION_DURATION, runHideAnimation };
